/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Mcp_Access_Create_KeyInputs */



/**
* | output |
* | --- |
* | "Create an API key" |
*
* @param {My_Integrations_Mcp_Access_Create_KeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_mcp_access_create_key = /** @type {((inputs?: My_Integrations_Mcp_Access_Create_KeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Mcp_Access_Create_KeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel erstellen")
	return /** @type {LocalizedString} */ ("Create an API key")
});